module.exports = __webpack_public_path__ + "img/SDD_cahora.3d952c69.jpg";